import { render, staticRenderFns } from "./WidgetPlaceholder.vue?vue&type=template&id=f040a1b6&"
import script from "./WidgetPlaceholder.vue?vue&type=script&lang=js&"
export * from "./WidgetPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports